import { FieldErrors, Resolver } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { FieldError } from 'react-hook-form/dist/types/errors'

import TransitOperationFormSchema, { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import setFieldErrorByPath from 'shared/rhf/setFieldErrorByPath'
import validateTransitOperationFormFieldStates from '../../form/validations/fieldStates/transitOperation'
import TransitOperationFormResolverContext from './TransitOperationFormResolverContext'

const transitOperationFormResolver: Resolver<TransitOperationFormValues, TransitOperationFormResolverContext> = async (
  values,
  context,
  options,
) => {
  const baseZodResolver = zodResolver(TransitOperationFormSchema)
  const zodResult = await baseZodResolver(values, context, options)

  const fieldErrors = validateTransitOperationFormFieldStates(values, {
    ...(context?.validationContextRef?.current ?? {
      specificCircumstanceIndicator: '',
      security: '0',
      isEns: false,
      additionalDeclarationType: 'A',
      country: null,
      isDraft: true,
    }),
    serverValidationResult: context?.serverValidationResult,
  })

  const errors: FieldErrors<TransitOperationFormValues> = { ...zodResult.errors }

  for (const err of fieldErrors) {
    const codeSuffix = err.code ? `:${err.code}` : ''
    setFieldErrorByPath(errors, err.path, {
      type: `ncts${codeSuffix}`,
      message: err.message,
    } as FieldError)
  }

  const hasErrors = Object.keys(errors).length > 0

  return {
    values: hasErrors ? {} : zodResult.values,
    errors,
  }
}

export default transitOperationFormResolver

